export const ProgramsItems = [
    'Quality Training ',
    'Quality Equipment',
    'Competitive & Non-Competitive Programs' 
]